import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-failed',
  templateUrl: './failed.component.html',
  styleUrls: ['./failed.component.scss']
})
export class ValidateCodeFailedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
